import React from 'react'
import moment from 'moment'
import {Badge, Button} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

const getBadgeColour = (status) => {
  switch(status){
    case 1:
      return 'warning'
      break
    case 2:
      return 'success'
      break
    case 3:
      return 'danger'
      break
    case 4:
      return 'dark'
      break
    default:
      return 'light'
  }
}

const AnnualLeaveListItem = (props) => {
  const {
    id,
    start_date,
    start_of_day,
    end_date,
    end_of_day,
    status,
    user,
    status_changed_by_user,
    status_change_date,
    reason,
    date_cancelled,
    date_created,
    days_used,
    canApprove,
    onApprove, 
    onReject,
    onCancel,
    onEdit,
  } = props
  return (
    <div className="d-flex flex-row justify-content-between border-bottom p-3">
      <div className="d-flex flex-column">
        <span className="lead">
          {moment(start_date).format('Do MMM YY')} ({start_of_day ? 'Start of Day' : 'Afternoon'}) 
          to{' '}
          {moment(end_date).format('Do MMM YY')} ({end_of_day ? 'End of Day' : 'Afternoon'})
        </span>
        {(status.id === 1 || status.id === 2) && <h6><Badge color="light" outline>{days_used} {(days_used > 1) ? 'Days' : 'Day'} Used</Badge></h6>}
        <span>
          <Badge color={getBadgeColour(status.id)}>{status.description}</Badge>
          {status_changed_by_user && 
            <small className="pl-2">
              By {status_changed_by_user.first_name} {status_changed_by_user.last_name} ({moment(status_change_date).format('Do MMM YY')})
            </small>}
          </span>
        <small className="pt-1">Requested By: {user.first_name} {user.last_name} ({moment(date_created).format('Do MMM YY')})</small>
      </div>
      <div className="d-flex flex-column">
        {status.id === 1 && canApprove && <div className="d-flex flex-column">
          <Button size="sm" color="success" className="mb-2" onClick={() => onApprove && onApprove(props)}>
            <FontAwesomeIcon
                color="#fff"
                icon="check"
            />{' '}Approve
          </Button>
          <Button size="sm" color="danger" className="mb-2" onClick={() => onReject && onReject(props)}>
            <FontAwesomeIcon
                color="#fff"
                icon="times"
            />{' '}Reject
          </Button>
        </div>}
        <Button size="sm" color="warning" className="mb-2" onClick={() => onEdit && onEdit(props)}>
          <FontAwesomeIcon
              color="#000"
              icon="edit"
          />{' '}Edit
        </Button>
        {status.id !== 4 && <Button size="sm" color="light" onClick={() => onCancel && onCancel(props)}>
          <FontAwesomeIcon
              color="#000"
              icon="trash-alt"
          />{' '}Cancel Leave
        </Button>}
      </div>
      
    </div>
  )
}

export default AnnualLeaveListItem